module.exports = __webpack_public_path__ + "static/make-integromat-7b0426effc7eaf357b9c31e68f8c2a08.svg";